import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { products, generateWhatsAppLink } from '../data/products';

const PriceList = () => {
    return (
        <section id="precios" className="py-20 md:py-28 bg-gradient-to-b from-dulce-pink-50/50 via-white to-dulce-cream-50/30 relative overflow-hidden">
            <div className="absolute top-10 right-10 text-6xl opacity-10 animate-float">🌸</div>
            <div className="absolute bottom-10 left-10 text-5xl opacity-10 animate-float-slow">🎂</div>

            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="animate-on-scroll">
                    <div className="text-center mb-12">
                        <span className="inline-block text-dulce-pink-500 text-sm font-semibold tracking-widest uppercase mb-3">
                            💰 Precios Especiales 💰
                        </span>
                        <h2 className="section-title text-gray-800">
                            Lista de <span className="text-gradient-pink">Precios</span>
                        </h2>
                        <p className="section-subtitle">Delicias artesanales a precios irresistibles 🎂</p>
                    </div>

                    <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-dulce-pink-100/50">
                        <div className="bg-gradient-to-r from-dulce-pink-400 via-dulce-rose-400 to-dulce-pink-500 p-6 text-center">
                            <h3 className="font-great-vibes text-3xl text-white">Repostería Dulce Mora</h3>
                            <p className="text-white/80 text-sm mt-1">Hecho con ingredientes naturales 🌿</p>
                        </div>

                        <div className="divide-y divide-dulce-pink-50">
                            {products.map((product) => (
                                <div key={product.id} className="flex items-center gap-4 p-4 md:p-5 hover:bg-dulce-pink-50/50 transition-colors group">
                                    <img src={product.image} alt={product.name} className="w-16 h-16 md:w-20 md:h-20 rounded-xl object-cover shadow-md group-hover:scale-105 transition-transform" loading="lazy" />
                                    <div className="flex-1 min-w-0">
                                        <h4 className={`font-playfair font-bold text-base md:text-lg ${product.accentColor}`}>{product.name}</h4>
                                        <p className="text-gray-500 text-xs md:text-sm truncate">{product.description}</p>
                                    </div>
                                    <div className="flex items-center gap-3 flex-shrink-0">
                                        <span className={`font-bold text-xl md:text-2xl ${product.accentColor}`}>${product.price}</span>
                                        <a href={generateWhatsAppLink(product.name, product.price)} target="_blank" rel="noopener noreferrer"
                                            className="bg-green-500 hover:bg-green-600 text-white p-2.5 rounded-full shadow-md transform hover:scale-110 transition-all">
                                            <FaWhatsapp size={18} />
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="bg-gradient-to-r from-dulce-pink-50 to-dulce-cream-50 p-5 flex flex-col md:flex-row items-center justify-between gap-3">
                            <div className="flex items-center gap-4 text-sm text-gray-600">
                                <span>💕 Hecho con amor</span>
                                <span>🌿 Ingredientes naturales</span>
                            </div>
                            <div className="text-sm text-dulce-pink-600 font-semibold">
                                🕐 Pedir con 24 horas de anticipación
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PriceList;